// IE 2026 10 25 / ODOO-348925 (заказ Игоря: ERD-вид схемы): ERD-вид схемы данных — чистая логика вкладки «ERD» группы «Поля» (тот же атрибут AttrSchemeGraph, params view: 'erd').
// Слово Игоря 25.10 ≈21:35Z (через ie-dm7 #104923): «добавь как ещё одну вкладку ERD-вид схемы в блок Поля». Контракт — бэк main 71b8d5d9f (PR #484, scheme_erd()):
// узел doc.nodes — КАРТОЧКА (заголовок title, вид kind справа, пилюли горизонтов doc.node_horizons: mode solid — залитая, dashed — пунктир), строки карточки — поля узла
// doc.node_fields (глиф роли FIELD-ROLE, подпись field.title из doc.fields, тег dim_role key / group / measure, ключи полужирным, use false — серым); группы верхнего уровня
// doc.nodes — смуги (колонки, цвет группы), цвет / заливка узла — как на графе (p028: nodes_color_binding / nodes_fill_binding). Линии — между СТРОКАМИ полей карточек
// по рёбрам doc.edges, правило field_link_rule 'same_name_dims_and_source_measure': одноимённые измерения (dim_role key / group) обоих узлов + мера source_measure → мера
// цели; нет — одноимённые меры; нет — первая мера источника → первая мера цели. Стиль линии — вид EDGE-KIND (edge_kinds, как граф v2), цвет строки ребра поверх
// (edges_color_binding); лаг — подписью у линии. Рёбра без source (меры факта / баланса, внешние источники) — чипы у меры цели (source_measure, text).
// Эталон вида и алгоритма — ie-dm7 erd-ref/gen.py (раскладка смуг, порты строк, петли внутри смуги, чипы, легенда) — перенесён по смыслу, ручные константы
// эталона (ширины смуг, порядок карточек, стороны чипов) заменены расчётом. Выключатель fe.ux.schemeGraphErd (§8, дефолт ВКЛ; выкл — при view 'erd' обычный граф).
// Тест: tests/unit/schemeGraphErd.test.mjs
import { t, tn } from '@/i18n'
import { getPath, keyOf, localized, SG_COLORS } from '@/utils/schemeGraph'
import { sg2Config, sg2Graph, sg2Kinds, sg2EdgeOwn, sg2Hex, sg2Mix, sg2FillText, sg2Readable, sg2NodeId } from '@/utils/schemeGraphV2'
import { sg2TrimPathEnd } from '@/utils/schemeGraphV2'   // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106105: граф схемы — наконечники, ⚑ прячет подсказки, высота, вид узлов): конец линии — внутри наконечника
import { normalizeLayout, layoutKey } from '@/utils/transitionsGraph'

export const SGE_FLAG = 'fe.ux.schemeGraphErd'
export function sgeOn(setting) {
    try { return (typeof setting === 'function' ? setting(SGE_FLAG, true) : true) !== false } catch (e) { return true }
}
const isObj = (v) => !!v && typeof v === 'object' && !Array.isArray(v)
const str = (v) => (v == null ? '' : String(v))
const r1 = (v) => Math.round(v * 10) / 10
// вид атрибута: params graph_view (верхний уровень атрибута или attr.params); 'erd' — ERD ('view' зарезервирован бэком, ie-dm7 #104969)
export function sgeView(attr) {
    if (!isObj(attr)) return ''
    const v = typeof attr.graph_view === 'string' ? attr.graph_view : isObj(attr.params) && typeof attr.params.graph_view === 'string' ? attr.params.graph_view : ''
    return v.trim().toLowerCase()
}
// рисовать ERD: graph_view 'erd' и выключатель включён (выкл — обычный граф v2)
export function sgeViewOn(attr, setting) { return sgeView(attr) === 'erd' && sgeOn(setting) }

// геометрия (px при масштабе 1) — константы эталона gen.py
export const SGE = Object.freeze({ margin: 24, bandHead: 36, bandPad: 16, bandGap: 8, laneGapMin: 200, cardMinW: 260, cardMaxW: 360, headH: 58, rowH: 26, rowPadT: 6, rowPadB: 8,
    cardGapMin: 48, chipW: 160, chipH: 34, chipGap: 6, chipLink: 36, loopBase: 22, loopStep: 11, loopK: 1.4, portSpan: 16, portStep: 5, corridorGap: 18, corridorStep: 8,
    legendTop: 28, legendRow: 26, noteRow: 16 })
// цвета эталона: смуги по порядку групп (нет своего цвета группы), чернила, приглушённый текст
export const SGE_LANE_COLORS = ['#2F6DA3', '#7A4EA3', '#23704A', '#B5651D', '#B53A5A', '#4F7F2E']
export const SGE_INK = '#263238'
export const SGE_MUTED = '#607D8B'
export const SGE_PLAIN = '#607D8B'   // выключатель цветов fe.ux.schemeGraphColors выкл — карточки нейтральные
const BG = '#FFFFFF'
// роль поля FIELD-ROLE → глиф (title записи словаря; бэк config_fields.FIELD_ROLE_SYMBOLS): id — голый код (dimension) или старый FIELD-ROLE_<код>; объект ссылки с title — его title
export const SGE_ROLE_GLYPH = Object.freeze({ dimension: '◇', resource: 'Σ', attribute: 'i' })
export const SGE_DIM_ROLES = ['key', 'group', 'measure']
export const SGE_RULE = 'same_name_dims_and_source_measure'

// ---------- конфигурация: граф v2 (sg2Config) + параметры ERD ----------
const DEFE = { node_fields_binding: '', node_fields_node_binding: 'node.name', node_fields_field_binding: 'field.name', node_fields_title_binding: 'field.title',
    node_fields_role_binding: 'role', node_fields_dim_role_binding: 'dim_role', node_fields_use_binding: 'use', node_fields_grid_name: '', fields_binding: '', fields_grid_name: '',
    node_horizons_binding: '', node_horizons_node_binding: 'node.name', node_horizons_horizon_binding: 'horizon.name', node_horizons_use_binding: 'use', node_horizons_mode_binding: 'mode',
    edges_source_measure_binding: 'source_measure', edges_text_binding: 'text', field_link_rule: SGE_RULE,
    // не передаются бэком (71b8d5d9f) — умолчания по записи DATA-SCHEME: таблица горизонтов (подписи пилюль и лага), лаг ребра, вид узла
    horizons_binding: 'doc.horizons', edges_lag_binding: 'lag.name', edges_horizon_binding: 'horizon.name', nodes_kind_binding: 'kind' }
export function sgeConfig(attr) {
    const a = isObj(attr) ? attr : {}
    const p = isObj(a.params) ? a.params : {}
    const pick = (k) => (typeof a[k] === 'string' ? a[k] : typeof p[k] === 'string' ? p[k] : undefined)
    const { cfg, errors } = sg2Config(attr)
    for (const k of Object.keys(DEFE)) { const v = pick(k); cfg[k] = v === undefined ? DEFE[k] : v.trim() }
    cfg.layout_mode = 'lanes'   // ERD — всегда смуги групп верхнего уровня
    if (!cfg.node_fields_binding) errors.push({ code: 'missing', params: ['node_fields_binding'] })
    return { cfg, errors }
}

// ---------- справочники записи: поля, горизонты ----------
function walkRows(rows, cfg, fn) {
    const go = (list) => (Array.isArray(list) ? list : []).forEach((row) => {
        if (!isObj(row)) return
        fn(row)
        const k = cfg.children_path ? getPath(row, cfg.children_path) : undefined
        if (Array.isArray(k)) go(k)
    })
    go(rows)
}
// doc.fields (дерево: группа — строка с attrs) → Map name → { name, title }
export function sgeFieldsMap(rows, cfg, lang) {
    const m = new Map()
    walkRows(rows, cfg, (row) => { const n = keyOf(getPath(row, 'name')); if (n && !m.has(n)) m.set(n, { name: n, title: localized(row, 'title', lang) || n }) })
    return m
}
// короткая подпись горизонта в пилюле: до 6 символов — как есть; длиннее — первые 5 без гласных в конце (Фактичний → Факт, Оперативний → Опер, Стратегічний → Страт)
export function sgeShort(title) {
    const s = str(title).trim()
    if (s.length <= 6) return s
    let x = s.slice(0, 5)
    while (x.length > 3 && /[aeiouyаеєиіїоуюяыэё]$/i.test(x)) x = x.slice(0, -1)
    return x
}
// doc.horizons → Map name → { name, title, short, order }
export function sgeHorizonsMap(rows, cfg, lang) {
    const m = new Map()
    let i = 0
    walkRows(rows, cfg, (row) => { const n = keyOf(getPath(row, 'name')); if (n && !m.has(n)) { const tt = localized(row, 'title', lang) || n; m.set(n, { name: n, title: tt, short: sgeShort(tt), order: i++ }) } })
    return m
}
const codeOf = (v) => { const k = keyOf(v); const i = k.lastIndexOf('_'); return (i >= 0 ? k.slice(i + 1) : k).toLowerCase() }
// глиф роли: объект ссылки с title — title; код словаря FIELD-ROLE — символ; иначе первая буква
export function sgeRoleGlyph(v) {
    if (isObj(v) && typeof v.title === 'string' && v.title.trim()) return v.title.trim()
    const c = codeOf(v)
    return SGE_ROLE_GLYPH[c] || (c ? c[0] : '')
}
const roleCode = (v) => { const c = codeOf(v); return SGE_ROLE_GLYPH[c] ? c : '' }
// dim_role: key | group | measure (перечисление; объект ссылки — его value / id)
const dimOf = (v) => { const c = keyOf(v).toLowerCase(); return SGE_DIM_ROLES.includes(c) ? c : '' }

// поля узлов: doc.node_fields → Map ключ узла → [{ index, node, field, title, glyph, role, dim, use }] (порядок строк таблицы)
export function sgeNodeFields(rows, cfg, lang, fields) {
    const m = new Map()
    ;(Array.isArray(rows) ? rows : []).forEach((row, index) => {
        if (!isObj(row)) return
        const node = keyOf(getPath(row, cfg.node_fields_node_binding)), field = keyOf(getPath(row, cfg.node_fields_field_binding))
        if (!node || !field) return
        const f = fields && fields.get(field)
        const title = (cfg.node_fields_title_binding ? localized(row, cfg.node_fields_title_binding, lang) : '') || (f && f.title) || field
        const rv = cfg.node_fields_role_binding ? getPath(row, cfg.node_fields_role_binding) : undefined
        const use = cfg.node_fields_use_binding ? getPath(row, cfg.node_fields_use_binding) !== false : true
        const it = { index, node, field, title, glyph: sgeRoleGlyph(rv), role: roleCode(rv), dim: cfg.node_fields_dim_role_binding ? dimOf(getPath(row, cfg.node_fields_dim_role_binding)) : '', use }
        if (!m.has(node)) m.set(node, [])
        m.get(node).push(it)
    })
    return m
}
// горизонты узлов: doc.node_horizons → Map ключ узла → [{ index, name, title, short, solid }] в порядке doc.horizons; mode solid — залитая, dashed — пунктир;
// mode пусто — по use (true — залитая); mode none / прочее при use false — без пилюли
export function sgeNodeHorizons(rows, cfg, horizons) {
    const m = new Map()
    ;(Array.isArray(rows) ? rows : []).forEach((row, index) => {
        if (!isObj(row)) return
        const node = keyOf(getPath(row, cfg.node_horizons_node_binding)), hz = keyOf(getPath(row, cfg.node_horizons_horizon_binding))
        if (!node || !hz) return
        const mode = cfg.node_horizons_mode_binding ? codeOf(getPath(row, cfg.node_horizons_mode_binding)) : ''
        const use = cfg.node_horizons_use_binding ? getPath(row, cfg.node_horizons_use_binding) : undefined
        let solid
        if (mode === 'solid') solid = true
        else if (mode === 'dashed') solid = false
        else if (!mode && use === true) solid = true
        else return
        const h = horizons && horizons.get(hz)
        if (!m.has(node)) m.set(node, [])
        const list = m.get(node)
        if (list.some((x) => x.name === hz)) return
        list.push({ index, name: hz, title: h ? h.title : hz, short: h ? h.short : sgeShort(hz), solid, order: h ? h.order : 1e6 + index })
    })
    for (const list of m.values()) list.sort((a, b) => a.order - b.order)
    return m
}

// ---------- связи полей по рёбрам (правило field_link_rule) ----------
// nf — sgeNodeFields; nodeKeys — ключи узлов-листьев. → { links: [{ id, edge, src, sfield, dst, dfield, conv, head }], externals: [{ id, edge, dst, dfield, measure, text, horizon }],
// dangling: [{ index, reason }], self: [index] }. Поля с use false в связях не участвуют. Ребро без единой пары полей — связь карточек (head: заголовок ↔ заголовок)
export function sgeFieldLinks(edgesRows, nf, nodeKeys, cfg) {
    const links = [], externals = [], dangling = [], self = []
    const live = (n) => (nf.get(n) || []).filter((r) => r.use)
    const dims = (n) => live(n).filter((r) => r.dim === 'key' || r.dim === 'group')
    const meas = (n) => { const out = []; for (const r of live(n)) if (r.dim === 'measure' && !out.includes(r.field)) out.push(r.field); return out }
    ;(Array.isArray(edgesRows) ? edgesRows : []).forEach((row, index) => {
        if (!isObj(row)) return
        const s = keyOf(getPath(row, cfg.edges_source_binding)), d = keyOf(getPath(row, cfg.edges_target_binding))
        if (!d || !nodeKeys.has(d)) { dangling.push({ index, reason: d ? 'missing' : 'empty' }); return }
        const sm = cfg.edges_source_measure_binding ? keyOf(getPath(row, cfg.edges_source_measure_binding)) : ''
        const tm = meas(d)
        if (!s) {
            externals.push({ id: `x:${index}`, edge: index, dst: d, dfield: tm.includes(sm) ? sm : (tm[0] || ''), measure: sm, horizon: cfg.edges_horizon_binding ? keyOf(getPath(row, cfg.edges_horizon_binding)) : '' })
            return
        }
        if (!nodeKeys.has(s)) { dangling.push({ index, reason: 'missing' }); return }
        if (s === d) { self.push(index); return }
        const add = (sf, df, conv) => { if (!links.some((l) => l.edge === index && l.sfield === sf && l.dfield === df)) links.push({ id: `l:${index}:${links.length}`, edge: index, src: s, sfield: sf, dst: d, dfield: df, conv: !!conv, head: false }) }
        const sd = new Set(dims(s).map((r) => r.field))
        for (const r of dims(d)) if (sd.has(r.field)) add(r.field, r.field)
        const smList = meas(s)
        if (sm && tm.includes(sm)) add(sm, sm)
        else {
            const common = smList.filter((m) => tm.includes(m))
            if (common.length) for (const m of common) add(m, m)
            else if (smList.length && tm.length) add(smList[0], tm[0], true)
        }
        if (!links.some((l) => l.edge === index)) links.push({ id: `l:${index}:${links.length}`, edge: index, src: s, sfield: '', dst: d, dfield: '', conv: false, head: true })
    })
    return { links, externals, dangling, self }
}

// ---------- оценка ширины текста (без canvas; эталон gen.py text_w) ----------
export const SGE_FONTS = Object.freeze({ title: [15, 1.06], kind: [10, 1.0, 0.8], pill: [11, 1.06], row: [13, 1], rowKey: [13, 1.06], tag: [10, 1, 0.2], chip: [11, 1.1], chipText: [10, 1],
    chipHz: [9, 1.06, 0.4], band: [12, 1.06, 1.4], bandN: [11, 1, 0.3], lag: [11, 1.06], leg: [12, 1], legHead: [12, 1.06, 0.6], note: [11.5, 1] })
export function sgeTextW(s, font) {
    const [size, k, ls] = SGE_FONTS[font] || [12, 1]
    let w = 0
    for (const ch of str(s)) {
        if ("iіїjlІ.,:;|!' ".includes(ch)) w += 0.32
        else if (ch !== ch.toLowerCase() || 'жшщмфюЖШЩМФЮ'.includes(ch)) w += 0.72
        else w += 0.56
    }
    return w * size * k + (ls || 0) * str(s).length
}
// обрезать по ширине с «…»
export function sgeFit(s, maxW, font, measure) {
    const m = typeof measure === 'function' ? measure : sgeTextW
    const x = str(s)
    if (m(x, font) <= maxW) return x
    let lo = 0, hi = x.length
    while (lo < hi) { const mid = (lo + hi + 1) >> 1; if (m(x.slice(0, mid) + '…', font) <= maxW) lo = mid; else hi = mid - 1 }
    return x.slice(0, lo).trimEnd() + '…'
}
// перенос по словам в ширину
export function sgeWrap(s, maxW, font, measure) {
    const m = typeof measure === 'function' ? measure : sgeTextW
    const out = []
    let cur = ''
    for (const w of str(s).split(/\s+/).filter(Boolean)) {
        const c = cur ? cur + ' ' + w : w
        if (!cur || m(c, font) <= maxW) cur = c
        else { out.push(cur); cur = w }
    }
    if (cur) out.push(cur)
    return out
}

// ---------- SVG-пути (эталон gen.py) ----------
const P = (x, y) => `${r1(x)},${r1(y)}`
export function sgePathCross(x0, y0, x1, y1) {
    const k = Math.abs(x1 - x0) * 0.5, sg = x1 > x0 ? 1 : -1
    return `M${P(x0, y0)} C${P(x0 + sg * k, y0)} ${P(x1 - sg * k, y1)} ${P(x1, y1)}`
}
export function sgePathLoop(x0, y0, y1, side, dpx, k = SGE.loopK) {
    const cx = x0 + side * dpx * k
    return `M${P(x0, y0)} C${P(cx, y0)} ${P(cx, y1)} ${P(x0, y1)}`
}
// обход через коридор под карточками (связь через смугу): от порта к щели у смуги источника, вниз в коридор, к щели у смуги цели, вверх к порту; углы — скругление r
export function sgePathCorridor(x0, y0, gx0, yc, gx1, x1, y1, r = 10) {
    const s0 = gx0 > x0 ? 1 : -1, s1 = x1 > gx1 ? 1 : -1, h = gx1 > gx0 ? 1 : -1
    const rr = Math.max(2, Math.min(r, Math.abs(gx0 - x0) / 2, Math.abs(x1 - gx1) / 2, Math.abs(yc - y0) / 2, Math.abs(yc - y1) / 2, Math.abs(gx1 - gx0) / 2))
    return `M${P(x0, y0)} L${P(gx0 - s0 * rr, y0)} Q${P(gx0, y0)} ${P(gx0, y0 + rr)} L${P(gx0, yc - rr)} Q${P(gx0, yc)} ${P(gx0 + h * rr, yc)} L${P(gx1 - h * rr, yc)} Q${P(gx1, yc)} ${P(gx1, yc - rr)}` +
        ` L${P(gx1, y1 + rr)} Q${P(gx1, y1)} ${P(gx1 + s1 * rr, y1)} L${P(x1, y1)}`
}
// точки пути (для проверок пересечения с карточками): M / L / Q / C абсолютные
export function sgePathPoints(d, step = 24) {
    const nums = (s) => s.trim().split(/[\s,]+/).filter(Boolean).map(Number)
    const out = []
    let cur = null
    for (const m of str(d).matchAll(/([MLQC])([^MLQC]*)/g)) {
        const v = nums(m[2])
        if (m[1] === 'M' || m[1] === 'L') { cur = { x: v[0], y: v[1] }; out.push(cur) }
        else if (m[1] === 'Q') { const [cx, cy, x, y] = v; for (let i = 1; i <= step; i++) { const t_ = i / step, u = 1 - t_; out.push({ x: u * u * cur.x + 2 * u * t_ * cx + t_ * t_ * x, y: u * u * cur.y + 2 * u * t_ * cy + t_ * t_ * y }) } cur = { x, y } }
        else if (m[1] === 'C') { const [ax, ay, bx, by, x, y] = v; for (let i = 1; i <= step; i++) { const t_ = i / step, u = 1 - t_; out.push({ x: u * u * u * cur.x + 3 * u * u * t_ * ax + 3 * u * t_ * t_ * bx + t_ * t_ * t_ * x, y: u * u * u * cur.y + 3 * u * u * t_ * ay + 3 * u * t_ * t_ * by + t_ * t_ * t_ * y }) } cur = { x, y } }
    }
    return out
}

// ---------- IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106105: граф схемы — наконечники, ⚑ прячет подсказки, высота, вид узлов) ----------
// карточка узла — общая для вкладки ERD и вида узлов «Картки» графа схемы (utils/schemeGraphNodeView.js): сборка, ширина по содержимому, подписи;
// рисует обе — компонент graph/SchemeErdCard.vue (координаты внутри карточки, место — translate). Наконечник линии: маркер длиной SGE_ARROW.len, линия обрезана
// на SGE_ARROW.trim (sg2TrimPathEnd), маркер сдвинут назад на столько же (refX = len − trim) — остриё на прежнем конце, под ним линии нет (тупой конец на увеличении)
export const SGE_ARROW = Object.freeze({ len: 9, trim: 5 })
// строки doc.nodes по пути (как collectNodes: '0.2.1')
export function sgeRowsAt(nodesRows, cfg) {
    const rowsAt = new Map()
    const walk = (list, path) => (Array.isArray(list) ? list : []).forEach((row, i) => {
        if (!isObj(row)) return
        const p = path.concat(i); rowsAt.set(p.join('.'), row)
        const k = cfg && cfg.children_path ? getPath(row, cfg.children_path) : undefined
        if (Array.isArray(k)) walk(k, p)
    })
    walk(nodesRows, [])
    return rowsAt
}
export const sgeKindTitles = () => ({ input: t('Input', null, 'scheme node kind'), derived: t('Derived', null, 'scheme node kind'), reference: t('Reference', null, 'scheme node kind'),
    supply: t('Supply', null, 'scheme node kind'), fact: t('Fact', null, 'scheme node kind') })
export const sgeDimTitles = () => ({ key: t('key', null, 'field dim role'), group: t('group', null, 'field dim role'), measure: t('measure', null, 'field dim role') })
export const sgeCardH = (n) => SGE.headH + SGE.rowPadT + n * SGE.rowH + SGE.rowPadB
// карточка листа: leaf — collectNodes (label, key, use, path, groups), v — лист sg2Graph (own, fill), row — строка doc.nodes;
// x: { cfg, nf, nh, colorsOn, laneColor, lane, gid, kindT, dimT }. Без места и ширины (x, y, w)
export function sgeCardOf(leaf, v, row, x) {
    const cfg = x.cfg
    const kc = codeOf(cfg.nodes_kind_binding ? getPath(row, cfg.nodes_kind_binding) : '')
    const own = x.colorsOn ? sg2Hex(v && v.own) : ''
    const color = own || x.laneColor
    const fill = x.colorsOn && !!own && !!(v && v.fill)
    const rows = (x.nf.get(leaf.key) || []).map((r) => ({ ...r, tag: x.dimT[r.dim] || r.dim, key: r.dim === 'key' }))
    const c = { id: leaf.key, key: leaf.key, title: leaf.label, kind: kc ? (x.kindT[kc] || kc) : '', lane: x.lane, gid: x.gid, color, fill, use: leaf.use, rows, pills: x.nh.get(leaf.key) || [],
        h: sgeCardH(rows.length), path: leaf.path, groups: leaf.groups.slice() }
    c.ink = fill ? sg2FillText(color) : SGE_INK
    c.muted = fill ? c.ink : SGE_MUTED
    c.titleInk = c.ink   // заголовок — чернилами, как эталон (цвет несут рамка и разделитель шапки)
    return c
}
// ширина карточки по содержимому (не уже cardMinW; предел cardMaxW ставит вызывающий — у смуги общий)
export function sgeCardW(c, m) {
    let w = SGE.cardMinW
    w = Math.max(w, m(c.title, 'title') + m(str(c.kind).toUpperCase(), 'kind') + 40)
    const pw = c.pills.reduce((a, p) => a + m(p.short, 'pill') + 20, 0) + 24
    w = Math.max(w, pw)
    for (const r of c.rows) w = Math.max(w, 34 + m(r.title, r.key ? 'rowKey' : 'row') + m(r.tag, 'tag') + 12 + 30)
    return w
}
// подписи карточки по её ширине: заголовок (обрезка «…»), пилюли (rx — от левого края карточки, x — с её местом c.x), строки полей (тег, текст)
export function sgeCardText(c, m) {
    const kw = c.kind ? m(str(c.kind).toUpperCase(), 'kind') : 0
    c.titleText = sgeFit(c.title, c.w - 30 - kw, 'title', m)
    const cx = Number(c.x) || 0
    let px = 12
    c.pillsAt = c.pills.map((p) => { const w = m(p.short, 'pill') + 14; const it = { ...p, rx: r1(px), x: r1(cx + px), w: r1(w) }; px += w + 6; return it })
    for (const r of c.rows) { r.tw = r1(m(r.tag, 'tag') + 12); r.text = sgeFit(r.title, c.w - 34 - r.tw - 18, r.key ? 'rowKey' : 'row', m) }
    return c
}
// цвета пилюли горизонта: карточка с заливкой / без, режим solid / dashed
export const sgePillFill = (c, p) => (c.fill ? (p.solid ? 'rgba(246,245,240,0.92)' : 'none') : (p.solid ? '#455A64' : '#FFFFFF'))
export const sgePillStroke = (c, p) => (p.solid ? 'none' : (c.fill ? c.ink : '#455A64'))
export const sgePillText = (c, p) => (c.fill ? (p.solid ? c.color : c.ink) : (p.solid ? '#FFFFFF' : '#455A64'))
// замер подписей шрифтом SVG (canvas): кегль / вес / межбуквенный — как стили карточки и ERD; без canvas — оценка sgeTextW
export const SGE_CANVAS_FONTS = Object.freeze({ title: [600, 15, 0], kind: [500, 10, 0.8], pill: [600, 11, 0], row: [400, 13, 0], rowKey: [700, 13, 0], tag: [500, 10, 0.2], chip: [500, 11, 0, 1],
    chipText: [400, 10, 0], chipHz: [600, 9, 0.4], band: [700, 12, 1.4], bandN: [500, 11, 0.3], lag: [600, 11, 0], leg: [400, 12, 0], legHead: [700, 12, 0.6], note: [400, 11.5, 0] })
export const SGE_MONO = 'ui-monospace, SFMono-Regular, Menlo, Consolas, monospace'
// getCtx() → CanvasRenderingContext2D | null, fam() → семейство шрифта; → (s, font) => ширина
export function sgeCanvasMeasure(getCtx, fam) {
    return (s, font) => {
        const f = SGE_CANVAS_FONTS[font] || [400, 12, 0]
        try {
            const ctx = getCtx()
            if (!ctx) return sgeTextW(s, font)
            ctx.font = `${f[0]} ${f[1]}px ${f[3] ? SGE_MONO : ((typeof fam === 'function' ? fam() : fam) || 'sans-serif')}`
            const x = String(s ?? '')
            return ctx.measureText(x).width * 1.04 + f[2] * x.length
        } catch (e) { return sgeTextW(s, font) }
    }
}

// ---------- модель ERD: карточки, смуги, линии, чипы, легенда ----------
// data: { nodesRows, edgesRows, nfRows, fieldsRows, nhRows, horizonsRows, layout }; o: { lang, measure(text, font), colorsOn, origin }
// → { W, H, bands, cards, links, chips, labels, legend, stats, dangling, kinds } | null (нет узлов)
export function sgeModel(data, cfg, o = {}) {
    const lang = o.lang || ''
    const m = typeof o.measure === 'function' ? o.measure : sgeTextW
    const colorsOn = o.colorsOn !== false
    const S = SGE
    const g = sg2Graph(data.nodesRows, [], { ...cfg, layout_mode: 'lanes' }, lang, undefined, undefined)
    if (!g.leaves.length) return null
    const fields = sgeFieldsMap(data.fieldsRows, cfg, lang)
    const horizons = sgeHorizonsMap(data.horizonsRows, cfg, lang)
    const nf = sgeNodeFields(data.nfRows, cfg, lang, fields)
    const nh = sgeNodeHorizons(data.nhRows, cfg, horizons)
    const kinds = sg2Kinds(cfg.edge_kinds, lang)
    // узлы: лист с ключом (дубли ключа — первый); строка doc.nodes — по пути collectNodes (вид узла)
    const rowsAt = sgeRowsAt(data.nodesRows, cfg)   // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106105: граф схемы — наконечники, ⚑ прячет подсказки, высота, вид узлов): общий с видом «Картки» графа
    const leafBy = new Map()
    g.nodes.leaves.forEach((l, i) => { if (l.key && !leafBy.has(l.key)) leafBy.set(l.key, { l, v: g.leaves[i] }) })
    const nodeKeys = new Set(leafBy.keys())
    const fl = sgeFieldLinks(data.edgesRows, nf, nodeKeys, cfg)
    // смуги: группы верхнего уровня по порядку (узлы вне групп — последней смугой); порядок карточек — сохранённая расстановка графа (по y), иначе строки doc.nodes
    const lay = normalizeLayout(data.layout)
    const lanes = (g.lanes || []).map((ln, li) => {
        const gr = g.groups.find((x) => x.gid === ln.gid)
        let ids = ln.leaves.slice()
        if (lay && ids.every((id) => lay[layoutKey(id)])) ids = ids.map((id, i) => [id, i]).sort((a, b) => lay[layoutKey(a[0])].y - lay[layoutKey(b[0])].y || a[1] - b[1]).map((x) => x[0])
        const own = gr ? sg2Hex(gr.color) : ''
        const color = colorsOn ? (own || SGE_LANE_COLORS[li % SGE_LANE_COLORS.length]) : SGE_PLAIN
        return { li, gid: ln.gid, key: gr ? gr.key : '', title: ln.title || '', color, ids }
    })
    const KIND_T = sgeKindTitles(), DIM_T = sgeDimTitles()   // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106105: граф схемы — наконечники, ⚑ прячет подсказки, высота, вид узлов)
    // карточки (размеры)
    const cards = [], cardBy = new Map()
    for (const ln of lanes) {
        const list = []
        for (const id of ln.ids) {
            const leaf = g.nodes.leaves.find((x) => sg2NodeId(x) === id)
            if (!leaf || !leaf.key || leafBy.get(leaf.key)?.l !== leaf) continue
            const v = leafBy.get(leaf.key).v
            const c = sgeCardOf(leaf, v, rowsAt.get(leaf.path), { cfg, nf, nh, colorsOn, laneColor: ln.color, lane: ln.li, gid: ln.gid, kindT: KIND_T, dimT: DIM_T })   // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106105: граф схемы — наконечники, ⚑ прячет подсказки, высота, вид узлов)
            cards.push(c); cardBy.set(c.id, c); list.push(c)
        }
        ln.cards = list
    }
    // ширина карточек смуги — по содержимому (cardMinW…cardMaxW)
    for (const ln of lanes) {
        let w = S.cardMinW
        for (const c of ln.cards) w = Math.max(w, sgeCardW(c, m))   // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106105: граф схемы — наконечники, ⚑ прячет подсказки, высота, вид узлов)
        ln.cw = Math.ceil(Math.min(S.cardMaxW, w))
        for (const c of ln.cards) c.w = ln.cw
    }
    // связи по картам смуг; связь к карточке без строки поля (заголовок) — порт на середине заголовка
    const laneOf = (id) => cardBy.get(id)?.lane
    const links = fl.links.filter((l) => cardBy.has(l.src) && cardBy.has(l.dst))
    const exts = fl.externals.filter((x) => cardBy.has(x.dst))
    const nL = lanes.length
    // стороны: в одной смуге — сторона петель смуги (сторона с меньшим числом межсмуговых концов; поровну — наружу: первая смуга — влево, иначе вправо)
    const endsL = new Array(nL).fill(0), endsR = new Array(nL).fill(0)
    for (const l of links) { const a = laneOf(l.src), b = laneOf(l.dst); if (a === b) continue; if (b > a) { endsR[a]++; endsL[b]++ } else { endsL[a]++; endsR[b]++ } }
    const loopSide = lanes.map((ln, i) => (endsL[i] < endsR[i] ? -1 : endsL[i] > endsR[i] ? 1 : i === 0 && nL > 1 ? -1 : 1))
    for (const l of links) {
        const a = laneOf(l.src), b = laneOf(l.dst)
        if (a === b) { l.sideS = l.sideT = loopSide[a]; l.mode = 'loop' } else { l.sideS = b > a ? 1 : -1; l.sideT = -l.sideS; l.mode = Math.abs(b - a) > 1 ? 'corridor' : 'cross' }
    }
    // чипы: сторона карточки с меньшим числом концов связей; поровну — наружу (последняя смуга — вправо, первая — влево)
    const sideCount = new Map()
    const bump = (id, side) => { const k = id + '|' + side; sideCount.set(k, (sideCount.get(k) || 0) + 1) }
    for (const l of links) { bump(l.src, l.sideS); bump(l.dst, l.sideT) }
    const chipSide = new Map()
    for (const x of exts) {
        if (chipSide.has(x.dst)) continue
        const L = sideCount.get(x.dst + '|-1') || 0, R = sideCount.get(x.dst + '|1') || 0, li = laneOf(x.dst)
        chipSide.set(x.dst, L < R ? -1 : L > R ? 1 : li === 0 && nL > 1 ? -1 : 1)
    }
    const chipsBy = new Map()
    for (const x of exts) { if (!chipsBy.has(x.dst)) chipsBy.set(x.dst, []); chipsBy.get(x.dst).push(x) }
    const chipStack = (n) => n * S.chipH + (n - 1) * S.chipGap
    // по вертикали: высота содержимого — самая высокая смуга (карточки + чипы ниже карточки + минимальный зазор); смуга распределяется по всей высоте, как эталон
    const effH = (c) => Math.max(c.h, chipsBy.has(c.id) ? chipStack(chipsBy.get(c.id).length) : 0)
    const TOP = S.margin + S.bandHead
    let contentH = 0
    for (const ln of lanes) contentH = Math.max(contentH, ln.cards.reduce((a, c) => a + effH(c), 0) + Math.max(0, ln.cards.length - 1) * S.cardGapMin)
    for (const ln of lanes) {
        const sum = ln.cards.reduce((a, c) => a + effH(c), 0), n = ln.cards.length
        const gap = n > 1 ? (contentH - sum) / (n - 1) : 0
        let y = TOP
        for (const c of ln.cards) { c.y = r1(y); y += effH(c) + gap }
    }
    for (const c of cards) {
        c.rowY = {}
        c.rows.forEach((r, i) => { r.y = c.y + S.headH + S.rowPadT + i * S.rowH; r.cy = r.y + S.rowH / 2; if (r.use && c.rowY[r.field] === undefined) c.rowY[r.field] = r.cy })
        c.headY = c.y + 23
    }
    const yOf = (id, f) => { const c = cardBy.get(id); return f && c.rowY[f] !== undefined ? c.rowY[f] : c.y + S.headH / 2 }
    // петли смуги: внутренние — короче (меньший изгиб), шаг loopStep
    const loopsBy = lanes.map(() => [])
    for (const l of links) if (l.mode === 'loop') loopsBy[laneOf(l.src)].push(l)
    for (const list of loopsBy) {
        list.sort((a, b) => Math.abs(yOf(a.src, a.sfield) - yOf(a.dst, a.dfield)) - Math.abs(yOf(b.src, b.sfield) - yOf(b.dst, b.dfield)) || a.edge - b.edge)
        list.forEach((l, k) => { l.dpx = S.loopBase + S.loopStep * k })
    }
    const bulge = (l) => l.dpx * S.loopK * 0.75   // наибольший вылет кубической петли
    // подписи лага: ребро с lag — одна подпись у его самой внешней линии
    const lagText = (index) => {
        const row = data.edgesRows[index]
        const lag = cfg.edges_lag_binding ? keyOf(getPath(row, cfg.edges_lag_binding)) : ''
        if (!lag) return null
        const h = horizons.get(lag)
        const neg = cfg.edge_sign_binding && Number(getPath(row, cfg.edge_sign_binding)) === -1
        return { a: (neg ? '− ' : '') + t('lag «{title}»', { title: h ? h.title : lag }), b: `(${lag})` }
    }
    const lagOf = new Map()
    for (const l of links) { const tx = lagText(l.edge); if (!tx) continue; const cur = lagOf.get(l.edge); if (!cur || (l.dpx || 0) > (cur.l.dpx || 0)) lagOf.set(l.edge, { l, tx }) }
    const lagW = (tx) => Math.max(m(tx.a, 'lag'), m(tx.b, 'lag')) + 8
    // ширины смуг: слева / справа от карточек — вылет петель (+ подпись лага), чипы за петлями, минимальная щель между карточками соседних смуг
    const loopRoom = lanes.map((ln, i) => {
        let r = 0
        for (const l of loopsBy[i]) { r = Math.max(r, bulge(l) + 8); const lg = lagOf.get(l.edge); if (lg && lg.l === l) r = Math.max(r, l.dpx + 12 + lagW(lg.tx)) }
        return r
    })
    // вылет петель смуги на стороне side, проходящих мимо карточки c (по высоте)
    const passBulge = (c, side) => {
        let r = 0
        for (const l of loopsBy[c.lane]) {
            if (l.sideS !== side) continue
            const y0 = Math.min(yOf(l.src, l.sfield), yOf(l.dst, l.dfield)), y1 = Math.max(yOf(l.src, l.sfield), yOf(l.dst, l.dfield))
            if (y1 >= c.y - 4 && y0 <= c.y + Math.max(c.h, chipsBy.has(c.id) ? chipStack(chipsBy.get(c.id).length) : 0) + 4) r = Math.max(r, bulge(l))
        }
        return r
    }
    for (const c of cards) if (chipsBy.has(c.id)) { const side = chipSide.get(c.id); c.chipSide = side; c.chipOff = Math.max(S.chipLink, passBulge(c, side) + 18) }
    const room = lanes.map((ln, i) => {
        let L = loopSide[i] < 0 ? loopRoom[i] : 0, R = loopSide[i] > 0 ? loopRoom[i] : 0
        for (const c of ln.cards) if (c.chipSide) { const need = c.chipOff + S.chipW + 8; if (c.chipSide < 0) L = Math.max(L, need); else R = Math.max(R, need) }
        return { L, R }
    })
    let x = S.margin
    const bands = []
    for (const [i, ln] of lanes.entries()) {
        let bx = x
        let cx = bx + S.bandPad + room[i].L
        if (i > 0) {
            const prevRight = bands[i - 1].cardX + lanes[i - 1].cw
            if (cx - prevRight < S.laneGapMin) { const d = S.laneGapMin - (cx - prevRight); bx += d; cx += d }
        }
        const head = m(ln.title.toUpperCase(), 'band') + m(tn(ln.cards.length, '{n} node', '{n} nodes'), 'bandN') + 48
        const bw = Math.max(S.bandPad * 2 + room[i].L + ln.cw + room[i].R, head)
        for (const c of ln.cards) c.x = r1(cx)
        bands.push({ li: i, gid: ln.gid, key: ln.key, title: ln.title, color: ln.color, tint: sg2Mix(ln.color, BG, 0.09), x: r1(bx), w: r1(bw), cardX: cx, count: ln.cards.length,
            countText: tn(ln.cards.length, '{n} node', '{n} nodes'), titleInk: sg2Readable(ln.color, sg2Mix(ln.color, BG, 0.09)) || ln.color })
        x = bx + bw + S.bandGap
    }
    let W = x - S.bandGap + S.margin
    const contentBottom = TOP + contentH
    // коридоры связей через смугу — под карточками
    const corr = links.filter((l) => l.mode === 'corridor')
    const corridorH = corr.length ? S.corridorGap + corr.length * S.corridorStep : 0
    // порты: несколько линий у одной строки и стороны — веером ±portSpan/2 (порядок — по y другого конца)
    const portReq = new Map()
    const req = (id, f, side, key, oy) => { const k = `${id}|${f}|${side}`; if (!portReq.has(k)) portReq.set(k, []); portReq.get(k).push({ key, oy }) }
    for (const l of links) { req(l.src, l.sfield, l.sideS, l.id, yOf(l.dst, l.dfield)); req(l.dst, l.dfield, l.sideT, l.id, yOf(l.src, l.sfield)) }
    const chips = []
    for (const [dst, list] of chipsBy) {
        const c = cardBy.get(dst), side = c.chipSide, total = chipStack(list.length)
        const top = Math.max(c.y, c.y + c.h / 2 - total / 2)
        const x0 = side < 0 ? c.x - c.chipOff - S.chipW : c.x + c.w + c.chipOff
        list.forEach((xx, j) => {
            const y0 = top + j * (S.chipH + S.chipGap)
            const row = data.edgesRows[xx.edge]
            const text = (cfg.edges_text_binding ? localized(row, cfg.edges_text_binding, lang) : '') || (cfg.edge_title_binding ? localized(row, cfg.edge_title_binding, lang) : '')
            const hz = horizons.get(xx.horizon)
            const kid = cfg.edge_kind_binding ? keyOf(getPath(row, cfg.edge_kind_binding)) : ''
            const k = (kid && kinds.byId.get(kid)) || kinds.def
            const own = colorsOn ? sg2EdgeOwn(row, cfg) : ''
            const ch = { id: xx.id, edge: xx.edge, dst, dfield: xx.dfield, measure: xx.measure || '?', text, hz: hz ? hz.short : sgeShort(xx.horizon), hzTitle: hz ? hz.title : xx.horizon, x: r1(x0), y: r1(y0),
                w: S.chipW, h: S.chipH, side, kind: k.id, kindTitle: k.builtin ? '' : k.title, color: own || k.color, width: k.width, dash: k.dash, cap: k.cap }
            ch.mText = sgeFit(ch.measure, S.chipW - 16 - m(ch.hz, 'chipHz') - 6, 'chip', m)
            ch.tText = sgeFit(text, S.chipW - 16, 'chipText', m)
            chips.push(ch)
            req(dst, xx.dfield, side, ch.id, y0 + S.chipH / 2)
        })
    }
    const portY = new Map()
    for (const [k, list] of portReq) {
        const [id, f] = k.split('|')
        const base = yOf(id, f)
        list.sort((a, b) => a.oy - b.oy)
        const n = list.length, span = Math.min(S.portSpan, S.portStep * (n - 1))
        list.forEach((p, i) => portY.set(p.key + '@' + k, base + (n === 1 ? 0 : -span / 2 + (span * i) / (n - 1))))
    }
    const py = (id, f, side, key) => portY.get(`${key}@${id}|${f}|${side}`)
    const edgeX = (c, side) => (side > 0 ? c.x + c.w : c.x)
    // щель между смугами i и i+1 (середина между карточками)
    const gapX = (i) => (bands[i].cardX + lanes[i].cw + bands[i + 1].cardX) / 2
    // линии
    const out = []
    let ci = 0
    const labels = []
    for (const l of links) {
        const cs = cardBy.get(l.src), ct = cardBy.get(l.dst)
        const row = data.edgesRows[l.edge]
        const kid = cfg.edge_kind_binding ? keyOf(getPath(row, cfg.edge_kind_binding)) : ''
        const k = (kid && kinds.byId.get(kid)) || kinds.def
        const own = colorsOn ? sg2EdgeOwn(row, cfg) : ''
        const use = cfg.edges_use_binding ? getPath(row, cfg.edges_use_binding) !== false : true
        const ys = py(l.src, l.sfield, l.sideS, l.id), yt = py(l.dst, l.dfield, l.sideT, l.id)
        const x0 = edgeX(cs, l.sideS), x1 = edgeX(ct, l.sideT)
        let d
        if (l.mode === 'loop') d = sgePathLoop(x0, ys, yt, l.sideS, l.dpx)
        else if (l.mode === 'cross') d = sgePathCross(x0, ys, x1, yt)
        else {
            const a = cs.lane, b = ct.lane
            const g0 = b > a ? gapX(a) : gapX(a - 1), g1 = b > a ? gapX(b - 1) : gapX(b)
            d = sgePathCorridor(x0, ys, g0, contentBottom + S.corridorGap + ci * S.corridorStep, g1, x1, yt)
            ci++
        }
        const lg = lagOf.get(l.edge)
        if (lg && lg.l === l) {
            if (l.mode === 'loop') labels.push({ edge: l.edge, x: r1(x0 + l.sideS * (l.dpx + 12)), y: r1((ys + yt) / 2), a: lg.tx.a, b: lg.tx.b, anchor: l.sideS > 0 ? 'start' : 'end', color: own || k.color })
            else labels.push({ edge: l.edge, x: r1((x0 + x1) / 2), y: r1((ys + yt) / 2 - 6), a: lg.tx.a, b: lg.tx.b, anchor: 'middle', color: own || k.color })
        }
        out.push({ id: l.id, edge: l.edge, src: l.src, sfield: l.sfield, dst: l.dst, dfield: l.dfield, conv: l.conv, head: l.head, mode: l.mode, d, kind: k.id, kindTitle: k.builtin ? '' : k.title,
            color: own || k.color, width: k.width, dash: k.dash, cap: k.cap, use, title: cfg.edge_title_binding ? localized(row, cfg.edge_title_binding, lang) : '',
            dl: sg2TrimPathEnd(d, SGE_ARROW.trim) })   // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106105: граф схемы — наконечники, ⚑ прячет подсказки, высота, вид узлов): dl — видимая линия (конец под наконечником)
    }
    for (const ch of chips) {
        const c = cardBy.get(ch.dst)
        const yt = py(ch.dst, ch.dfield, ch.side, ch.id), yc = ch.y + S.chipH / 2
        ch.d = ch.side < 0 ? sgePathCross(ch.x + S.chipW, yc, c.x, yt) : sgePathCross(ch.x, yc, c.x + c.w, yt)
        ch.dl = sg2TrimPathEnd(ch.d, SGE_ARROW.trim)   // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106105: граф схемы — наконечники, ⚑ прячет подсказки, высота, вид узлов)
    }
    // правая граница: петли / чипы / подписи не выходят за последнюю смугу (смуга их учитывает); подписи лага — запас
    for (const lb of labels) if (lb.anchor === 'start') W = Math.max(W, lb.x + m(lb.a, 'lag') + S.margin)
    // легенда (как эталон): «Зв’язки» — виды, что есть на схеме, и образец чипа; «Поля» — глифы ролей, теги, пилюли; примечание — правило связей
    const usedKinds = new Set([...out.map((l) => l.kind), ...chips.map((c) => c.kind)])
    const legendKinds = kinds.list.filter((k) => usedKinds.has(k.id))
    if (usedKinds.has(kinds.def.id) && !legendKinds.includes(kinds.def)) legendKinds.push(kinds.def)
    const LY = contentBottom + corridorH + S.legendTop + 8
    const legend = { y: LY, items: [], fields: [], notes: [] }
    legend.headLinks = t('Links', null, 'legend'); legend.headFields = t('Fields', null, 'legend'); legend.x0 = S.margin + 6
    let lx = legend.x0 + Math.max(m(legend.headLinks.toUpperCase(), 'legHead'), m(legend.headFields.toUpperCase(), 'legHead')) + 16
    legend.x1 = lx
    for (const k of legendKinds) {
        const lab = k.title || t('Link', null, 'graph')
        legend.items.push({ id: k.id || '~', x: r1(lx), title: lab, color: k.color, width: k.width, dash: k.dash, cap: k.cap })
        lx += 54 + m(lab, 'leg') + 26
    }
    if (chips.length) { legend.chip = { x: r1(lx), sample: t('measure', null, 'field dim role'), title: t('external source (fact or balance measure, not a node)') }; lx += 52 + m(legend.chip.title, 'leg') + 12 }
    let fx = legend.x1
    const roleItems = [['◇', t('dimension', null, 'field role')], ['Σ', t('resource', null, 'field role')], ['i', t('attribute', null, 'field role')]]
    for (const [gl, lab] of roleItems) { legend.fields.push({ x: r1(fx), glyph: gl, title: lab }); fx += 14 + m(lab, 'leg') + 22 }
    legend.tags = t('tags {key} / {group} / {measure} — the role of the field in the node (dim_role), keys in bold · horizon pills: filled — solid mode, dotted — dashed · filled cards — result nodes',
        { key: DIM_T.key, group: DIM_T.group, measure: DIM_T.measure })
    W = Math.max(W, lx + S.margin, fx + S.margin)
    const note = t('Field links are derived from the node links (doc.edges): for each link node → node the same-name dimensions (key / group) of both nodes are joined, and the source measure (source_measure) → the target measure; source_measure empty — the same-name measures, otherwise the first measure of the source → the first measure of the target. Links without a source (source empty) are shown as external sources attached to a measure of the target node.')
    legend.notes = [...sgeWrap(legend.tags, W - 2 * S.margin - 12, 'note', m), ...sgeWrap(note, W - 2 * S.margin - 12, 'note', m)]
    const H = LY + 2 * S.legendRow + legend.notes.length * S.noteRow + S.margin
    // подписи строк карточек — обрезка по ширине
    for (const c of cards) sgeCardText(c, m)   // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106105: граф схемы — наконечники, ⚑ прячет подсказки, высота, вид узлов)
    for (const b of bands) b.titleText = str(b.title).toUpperCase()
    const nEdges = new Set(fl.links.map((l) => l.edge)).size
    return { W: Math.ceil(W), H: Math.ceil(H), top: TOP, contentBottom, bands, cards, links: out, chips, labels, legend, kinds,
        dangling: fl.dangling, self: fl.self,
        stats: { nodes: cards.length, groups: bands.length, fields: cards.reduce((a, c) => a + c.rows.length, 0), edges: nEdges, lines: out.filter((l) => !l.head).length, heads: out.filter((l) => l.head).length,
            external: chips.length, conversions: out.filter((l) => l.conv).length, corridors: corr.length } }
}

// ---------- взаимное выделение ----------
// sel: {node} | {edge: индекс строки doc.edges} | {nf: индекс строки doc.node_fields} | {field: имя поля doc.fields} | {group: gid} | null
// → { cards: Set(id), rows: Set('узел|поле'), links: Set(id), chips: Set(id), bands: Set(gid), any }
export function sgeHighlight(model, sel) {
    const cards = new Set(), rows = new Set(), links = new Set(), chips = new Set(), bands = new Set()
    const res = () => ({ cards, rows, links, chips, bands, any: cards.size + rows.size + links.size + chips.size + bands.size > 0 })
    if (!model || !sel) return res()
    const lk = (l) => { links.add(l.id); if (l.sfield) rows.add(l.src + '|' + l.sfield); if (l.dfield) rows.add(l.dst + '|' + l.dfield) }
    if (sel.node) {
        const id = String(sel.node)
        cards.add(id)
        for (const l of model.links) if (l.src === id || l.dst === id) lk(l)
        for (const c of model.chips) if (c.dst === id) chips.add(c.id)
    } else if (sel.edge !== undefined && sel.edge !== null) {
        const e = Number(sel.edge)
        for (const l of model.links) if (l.edge === e) { lk(l); cards.add(l.src); cards.add(l.dst) }
        for (const c of model.chips) if (c.edge === e) { chips.add(c.id); cards.add(c.dst); if (c.dfield) rows.add(c.dst + '|' + c.dfield) }
    } else if (sel.nf !== undefined && sel.nf !== null) {
        const i = Number(sel.nf)
        for (const c of model.cards) for (const r of c.rows) if (r.index === i) {
            rows.add(c.id + '|' + r.field)
            for (const l of model.links) if ((l.src === c.id && l.sfield === r.field) || (l.dst === c.id && l.dfield === r.field)) lk(l)
            for (const ch of model.chips) if (ch.dst === c.id && ch.dfield === r.field) chips.add(ch.id)
        }
    } else if (sel.field) {
        const f = String(sel.field)
        for (const c of model.cards) for (const r of c.rows) if (r.field === f) rows.add(c.id + '|' + f)
        for (const l of model.links) if (l.sfield === f || l.dfield === f) lk(l)
    } else if (sel.group) {
        bands.add(String(sel.group))
        for (const c of model.cards) if (c.gid === sel.group || (c.groups || []).includes(sel.group)) cards.add(c.id)
    }
    return res()
}
// строка doc.node_fields: ключ для сверки с гридом без той же ссылки — узел + поле
export function sgeNfKey(row, cfg) { return isObj(row) ? keyOf(getPath(row, cfg.node_fields_node_binding)) + '\u0001' + keyOf(getPath(row, cfg.node_fields_field_binding)) : '' }
// имя поля строки грида doc.fields
export function sgeFieldName(row) { return isObj(row) ? keyOf(getPath(row, 'name')) : '' }
